var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.setup.business && _vm.setup.business.gmap)?_c('iframe',{style:(("width:100%;height:" + (_vm.height || 300) + "px")),attrs:{"src":_vm.setup.business.gmap,"frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }